import { create } from 'zustand';
import { servicesAPI } from '../api/services';

const useServiceStore = create((set) => ({
  services: [],
  service: null,
  loading: false,
  error: null,
  pagination: { current: 1, pageSize: 15, total: 0 },

  fetchServices: async (params = {}) => {
    set({ loading: true });
    try {
      const res = await servicesAPI.getAll(params);
      const data = res.data?.data || res.data;
      set({
        services: Array.isArray(data) ? data : data?.data || [],
        pagination: {
          current: data?.current_page || 1,
          pageSize: data?.per_page || 15,
          total: data?.total || 0,
        },
        loading: false,
      });
    } catch (err) {
      set({ error: err.message, loading: false });
    }
  },

  fetchService: async (id) => {
    set({ loading: true });
    try {
      const res = await servicesAPI.getOne(id);
      set({ service: res.data?.data || res.data, loading: false });
    } catch (err) {
      set({ error: err.message, loading: false });
    }
  },

  createService: async (data) => {
    const res = await servicesAPI.create(data);
    return res.data;
  },

  updateService: async (id, data) => {
    const res = await servicesAPI.update(id, data);
    return res.data;
  },

  deleteService: async (id) => {
    await servicesAPI.delete(id);
  },
}));

export default useServiceStore;
